module.exports = __webpack_public_path__ + "static/media/pm_softspot_logo.13a30562.svg";